import { JsonProperty, ObjectMapper } from 'json-object-mapper';
import { IModel } from '../IModel';
import { Model } from '../model';

export class RecruitmentReassignmentDetailsModel
  extends Model
  implements IModel<RecruitmentReassignmentDetailsModel>
{
  @JsonProperty()
  public targetJobTitle: string = '';

  @JsonProperty()
  public targetDescription: string | null = null;

  @JsonProperty()
  public targetResponsabilities: string | null = null;

  @JsonProperty()
  public targetTechnicalRequirements: string | null = null;

  @JsonProperty()
  public targetBehavioralRequirements: string | null = null;

  @JsonProperty()
  public targetBenefits: string | null = null;

  @JsonProperty()
  public recruiterMessage: string | null = null;

  static create(input: any): RecruitmentReassignmentDetailsModel {
    return ObjectMapper.deserialize<RecruitmentReassignmentDetailsModel>(
      RecruitmentReassignmentDetailsModel,
      input ?? {}
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
